/**
 * On demand polyfill import using import()
 *
 * @see https://webpack.js.org/guides/code-splitting-async/
 * @see http://anzorb.com/we-dont-need-your-polyfills/
 * @see https://hackernoon.com/polyfills-everything-you-ever-wanted-to-know-or-maybe-a-bit-less-7c8de164e423
 * @see http://anujnair.com/blog/13-conditionally-load-multiple-polyfills-using-webpack-promises-and-code-splitting
 *
 */
/* eslint-disable */

/**
 * NOTE: CRA includes a polyfill for promise and fetch by default
 */

export default function polyfill() {
  const promises = [
    // check core es6 features
    new Promise(resolve => {
      const supportsES6 =
        "assign" in Object &&
        "keys" in Object &&
        "includes" in Array.prototype &&
        "fill" in Array.prototype;
      if (supportsES6) return resolve();

      return require.ensure(
        [],
        () => {
          require("core-js/shim");
          resolve();
        },
        "core-js"
      );
    }),

    // check for IE11
    new Promise(resolve => {
      // ie11:  'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
      const ua = window.navigator.userAgent;
      if (!(/Trident/.test(ua) && ua.indexOf("rv:"))) return resolve();
      return require.ensure(
        [],
        () => {
          require("./utils/polyfills/ie11");
          resolve();
        },
        "ie11-polyfill"
      );
    })
  ];

  return Promise.all(promises);
}



// WEBPACK FOOTER //
// ./src/polyfill.js